import Footer from "../components/Footer";
import "../styles/ComingSoon.css";

function ComingSoon() {
  return (
    <>
    <section className="coming-soon">
      <div className="coming-soon__overlay"></div>
      <div className="coming-soon__content">
        <p className="coming-soon__label">En cours de préparation,</p>
        <h1 className="coming-soon__title">Revenez prochainement !</h1>
      </div>


      
    </section>

    <Footer backgroundColor="black" />
    </>
  );
}

export default ComingSoon;